import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const BannedService = {
    requestList: async (language = "english") => {
        const param = { language };
        const result = await ApiService.getData("/v1/banned", param);
        // Logger.log(result);
        return result;
    },

    addWord: async (category, word, meaning = "", language = "english") => {
        const data = {
            category: category,
            word: word,
            meaning: meaning,
            language: language
        };
        const result = await ApiService.postData("/v1/banned", data);
        if (result && result.code === "FAILURE") {
            throw new Error(result.message || "Failed to add banned word");
        }
        return result;
    },

    deleteWord: async (id) => {
        const result = await ApiService.deleteData(`/v1/banned/${id}`);
        return result;
    }
};

export default BannedService;
